import { createContext, useContext, useMemo } from 'react'

import type { TParametrosSimulacao } from '@/types/parametros-simulacao'
import type { TTabelaDePrecoProduto } from '@/types/simulacao'

type TParametrosSimulacaoContextValue = TParametrosSimulacao & {
  tabelaDePreco?: TTabelaDePrecoProduto
}

const ParametrosSimulacaoContext = createContext<TParametrosSimulacaoContextValue | null>(null)

export const useParametrosSimulacaoContext = () => {
  const context = useContext(ParametrosSimulacaoContext)
  if (!context) {
    throw new Error('useParametrosSimulacaoContext must be used within a ParametrosSimulacaoProvider')
  }

  const parametrosEstaticos = useMemo(
    () => ({
      parametrosTaxaDeCambioChile: context.parametrosTaxaDeCambioChile,
      parametrosTaxaAnualDividendos: context.parametrosTaxaAnualDividendos,
    }),
    [context.parametrosTaxaDeCambioChile, context.parametrosTaxaAnualDividendos],
  )

  return { ...context, parametrosEstaticos }
}

export const ParametrosSimulacaoProvider = ({
  children,
  value,
}: {
  children: React.ReactNode
  value: TParametrosSimulacaoContextValue
}) => <ParametrosSimulacaoContext.Provider value={value}>{children}</ParametrosSimulacaoContext.Provider>
